import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

const read = (k, fallback) => {
  try {
    return JSON.parse(localStorage.getItem(k)) ?? fallback;
  } catch {
    return fallback;
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => read("ayushi-user", null));
  const [orders, setOrders] = useState(() => read("ayushi-orders", []));
  const [addresses, setAddresses] = useState(() => read("ayushi-addresses", []));

  useEffect(() => localStorage.setItem("ayushi-user", JSON.stringify(user)), [user]);
  useEffect(() => localStorage.setItem("ayushi-orders", JSON.stringify(orders)), [orders]);
  useEffect(() => localStorage.setItem("ayushi-addresses", JSON.stringify(addresses)), [addresses]);

  const completeSignIn = (mobile) => {
    const users = read("ayushi-users", {});
    const existing = users[mobile];
    if (existing) {
      setUser({ mobile, name: existing.name, email: existing.email });
      return { needsName: false };
    }
    return { needsName: true };
  };

  const registerName = (mobile, name) => {
    const users = read("ayushi-users", {});
    users[mobile] = { name };
    localStorage.setItem("ayushi-users", JSON.stringify(users));
    setUser({ mobile, name });
  };

  const updateDetails = (details) => {
    if (!user) return;
    const next = { ...user, ...details };
    setUser(next);
    const users = read("ayushi-users", {});
    users[user.mobile] = { name: next.name, email: next.email };
    localStorage.setItem("ayushi-users", JSON.stringify(users));
  };

  const signOut = () => setUser(null);

  const addOrder = (order) => setOrders((prev) => [order, ...prev]);

  const saveAddress = (address) => {
    setAddresses((prev) => {
      const next = address.default ? prev.map((a) => ({ ...a, default: false })) : prev;
      const existing = next.findIndex((a) => a.id === address.id);
      if (existing >= 0) {
        const copy = [...next];
        copy[existing] = address;
        return copy;
      }
      return [...next, { ...address, default: address.default || next.length === 0 }];
    });
  };
  const deleteAddress = (id) => setAddresses((prev) => prev.filter((a) => a.id !== id));

  return (
    <AuthContext.Provider
      value={{ user, orders, addresses, completeSignIn, registerName, updateDetails, signOut, addOrder, saveAddress, deleteAddress }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
